<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ page.title }}</div>
        <!-- 提交按钮 -->
        <div v-if="activeIndex === 0" class="pageButton">
          <button type="button" class="btn btn-primary" @click="clkApply()">
            {{ "Apply" }}
          </button>
          <span style="margin-left: 10px">
            <button
              type="button"
              class="btn btn-default"
              style="min-width: 77px"
              @click="clkCancel()"
            >
              {{ "Cancel" }}
            </button>
          </span>
        </div>
      </div>
    </div>
    <!-- 页面提示 -->
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ page.desc }}
      </p>
    </div>
    <div>
      <span style="margin: 1px"></span>
    </div>
    <div>
      <tabs v-model="activeIndex">
        <!-- 端口配置 -->
        <pane label="Config">
          <port-config ref="config"></port-config>
        </pane>
        <!-- 端口光参数 -->
        <pane label="Optical">
          <port-optical></port-optical>
        </pane>
        <!-- 端口统计 -->
        <pane label="Statistics">
          <port-statistics></port-statistics>
        </pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import tabs from "@/components/Tabs.vue"
import pane from "@/components/Pane.vue"
import PortConfig from "./PortConfig.vue"
import PortOptical from "./PortOptical.vue"
import PortStatistics from "./PortStatistics.vue"
import cryptoJs from "crypto-js"
export default {
  data() {
    return {
      page: en.page.port,
      activeIndex: 0,
    }
  },
  components: {
    tabs,
    pane,
    PortConfig,
    PortOptical,
    PortStatistics,
  },
  created() {
    this.pageInit(this.activeIndex)
  },
  methods: {
    pageInit(val) {
      switch (val) {
        case 0:
          this.page = en.page.portstatus
          break
        case 1:
          this.page = en.page.portoptical
          break
        case 2:
          this.page = en.page.portstatistics
          break
        default:
          break
      }
    },

    clkApply() {
      this.$refs["config"].clkApply()
    },
    clkCancel() {
      this.$refs["config"].clkCancel()
    },
  },
  watch: {
    activeIndex(val) {
      this.pageInit(val)
    },
  },
}
</script>